export const zIndices = {
  sidebar: 1450,
  drawer: 1470,
  mobileBanner: 1500,
}
